import { useEffect, useState } from "react";
import { usePageState } from "../../../Layout";
import {
  apiOnlineMenuUrl,
  executeRequest,
  getApplicationToken,
  getToken,
} from "../../../functions/requests";
import Spacer from "../../../components/Spacer";
import Button from "../../../components/Button";
import IconLoadingWave from "../../../icons/IconLoadingWave";
import { useNavigate } from "react-router-dom";

export default function OnlineMenu() {
  const { pageState, setPageState } = usePageState();
  const navigate = useNavigate();

  const [userData, setUserData] = useState(pageState.userData);
  const [localUserData, setLocalUserData] = useState(null);
  const [userDataLoading, setUserDataLoading] = useState(true);
  const [overviewData, setOverviewData] = useState(null);

  const getApplicationData = async () => {
    console.log(getApplicationToken("online_menu"));
    // Get connected user data
    await executeRequest(
      apiOnlineMenuUrl + "users/current",
      "GET",
      null,
      {
        Authorization: "Bearer " + getApplicationToken("online_menu"),
      },
      async (data) => {
        setLocalUserData(data);
        console.log(data);
      },
      (error) => {
        console.log(error);
      }
    );
    setUserDataLoading(false);
    // If user, get overview data
    if (userData.user_type !== "user") return;
    await executeRequest(
      apiOnlineMenuUrl + "overview",
      "GET",
      null,
      {
        Authorization: "Bearer " + getApplicationToken("online_menu"),
      },
      async (data) => {
        setOverviewData(data);
        console.log(data);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  useEffect(() => {
    getApplicationData();
    console.log(getToken());
  }, []);

  // Loading screen
  if (userDataLoading) {
    return (
      <>
        <h1 className="page-title">Online Menu</h1>
        <IconLoadingWave />
      </>
    );
  }

  // Show users page
  if (localUserData.central_system_role === "user") {
    return (
      <>
        <h1 className="page-title">Online Menu</h1>
        <h2>Users admin panel</h2>
        <Spacer height="10px" />
        <div className="information">
          Here you can view and edit information about the online menu
          application.
        </div>
        <Spacer />
        {overviewData !== null && (
          <>
            <h2>Total users: {overviewData.total_users}</h2>
            <Spacer height="10px" />
            <h2>Total owners: {overviewData.total_owners}</h2>
            <Spacer height="10px" />
            <h2>Total menu settings: {overviewData.total_menu_settings}</h2>
          </>
        )}
      </>
    );
  }

  // Determine whether or not to show not subscribed page
  var showNotSubscribedPage = false;
  // If user is a customer, check if they have subcsription
  if (
    localUserData.central_system_role !== "user" &&
    localUserData.subscriptions
  ) {
    const onlineMenuSubscription = localUserData.subscriptions.find(
      (subscription) => subscription.plan?.application?.slug === "online_menu"
    );

    if (!onlineMenuSubscription) {
      showNotSubscribedPage = true;
    }
  } else {
    showNotSubscribedPage = true;
  }
  // Show not subscribed page
  if (showNotSubscribedPage) {
    return (
      <div>
        <h1 className="page-title">Online Menu</h1>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: "var(--spaceM)",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h2>You have not purchased a subscription for this product yet.</h2>
          <Button
            text="Purchase here"
            onClicked={() => navigate("/checkout")}
          />
        </div>
      </div>
    );
  }

  // Show normal page
  return (
    <div>
      <h1 className="page-title">Online Menu</h1>
      {userDataLoading ? (
        <IconLoadingWave />
      ) : (
        userData && (
          <>
            <h2>Select what to view</h2>
            <Spacer />
            <div className="flex flex-gap-s">
              <Button
                text="Menu Setups"
                onClicked={() => {
                  navigate("/projects/online-menu/menu-settings");
                }}
              />
              <Button
                text="Orders"
                onClicked={() => {
                  navigate("/projects/online-menu/orders");
                }}
              />
            </div>
          </>
        )
      )}
    </div>
  );
}
